import React from "react";
import { List, Menu, Hash, Italic } from "lucide-react";

const iconForFieldType = (fieldType: string | undefined) => {
  if (fieldType?.endsWith("[]")) {
    return <List size={12} />;
  }
  switch (fieldType) {
    case "Object":
      return <List size={12} />;
    case "Array":
      return <Menu size={12} />;
    case "Number":
      return <Hash size={12} />;
    default:
      return <Italic size={12} />;
  }
};

interface Props {
  fieldType: string | undefined;
}

const FieldTypeIcon = ({ fieldType }: Props) => (
  <div className="avatar-xs avatar-title rounded-circle ml-0.5 mr-3">
    {iconForFieldType(fieldType)}
  </div>
);

export default FieldTypeIcon;
